export const formatAmount = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '';
  const str = String(value);
  if (!/^-?\d+(\.\d+)?$/.test(str)) return str;
  const [intPart, decPart] = str.split('.');
  const sign = intPart.startsWith('-') ? '-' : '';
  const digits = sign ? intPart.slice(1) : intPart;
  const formattedInt = sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
};
